import { Api, Config } from './api'

export const ApiObterPeriodosApuracao = async (filtros) => {
   const params = new URLSearchParams()
   if (filtros.pagina) {
      params.append('pagina', filtros.pagina)
   }

   if (filtros.limite) {
      params.append('limite', filtros.limite)
   }
   const { data } = await Api.get(`/referencia/periodo`, Config(params))

   return data
}

export const ApiObterPorIdPeriodoApuracao = async (id) => {
   const { data } = await Api.get(`/referencia/${id}/periodo`, Config())

   return data
}

export const ApiEditarPeriodoApuracao = async (payload) => {
   const { data } = await Api.put(`/referencia/${payload.id}`, payload.body, Config())

   return data
}

export const ApiRegistrarPeriodoApuracao = async (payload) => {
   const { data } = await Api.post(`/referencia/periodo`, payload, Config())

   return data
}

export const ApiDeletarPeriodoApuracao = async (id) => {
   const { data } = await Api.delete(`/referencia/${id}/deletar`, Config())

   return data
}
